// extracted by mini-css-extract-plugin
export var buttonContainer = "_7i-1";
export var fontSizeSelect = "_7i-3";
export var formatSelect = "_7i-2";
export var formats = "_7i-4";
export var hidden = "_7i-5";
export var icon = "_7i-6";
export var select = "_7i-0";